var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaTiposUnidad",
        attrs: {
          filterStatus: _vm.filterStatus,
          createButton: false,
          editButton: false,
          deleteButton: false,
          path: _vm.url + "/tipos-unidad/search",
          columns: [
            {
              display: "Nombre",
              value: "nombre"
            },
            {
              display: "Descripción",
              value: "descripcion"
            },
            {
              display: "Fecha de creación",
              value: "created_at"
            },
            {
              display: "Fecha de modificación",
              value: "updated_at"
            }
          ]
        },
        on: { crear: _vm.crear, seleccionar: _vm.seleccionar }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Tipos de unidad")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2571c74d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2571c74d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/tipos-unidad/ListaTiposUnidad.vue
// module id = 372
// module chunks = 0